module.exports = __webpack_public_path__ + "static/media/road-D.e36e95f7.svg";